export default __webpack_public_path__ + "static/img-app-explain-e766d652197c15c5d847252a128a0a96.webp";